module.exports = __webpack_public_path__ + "media/images/flags/16/Bangladesh-79b8d7714104df979594925c24eb1a7e.png";